/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import { NumberOfSearchResultsInDocument } from "components/search/NumberSearchResultsInDocument";
import { getIndexOfCurrentSearchResult, getNumberOfSearchResultsInDocument } from "selectors/searchSelectors";
import { getShouldUseModernViewer } from "selectors/appSelectors";
import { withTheme } from "context/themeContext";

const mapStoreToProps = (stores, ownProps) => ({
  useModernViewer: getShouldUseModernViewer(stores),
  numberOfSearchResultsInDocument: getNumberOfSearchResultsInDocument(stores),
  indexOfCurrentSearchResult: getIndexOfCurrentSearchResult(stores)
});

export const NumberOfSearchResultsContainer = inject(mapStoreToProps)(withTheme(NumberOfSearchResultsInDocument));
